
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './component/ScrollToTop';
import Navbar from './component/Navbar.js';
import Hero from './component/Hero.js';
import NotFound from './component/NotFound.js';
import Containt from './component/containt.js';
import Footer from './component/Footer.js';
import { Helmet } from "react-helmet";

function App() {
  return (
    <Router>
    <Helmet>
        <meta name="description" content="Welcome to Issa Al-Tabbal's official website. Learn more about him here!" />
        <meta name="keywords" content="Issa Al-Tabbal, issaaltabbal, عيسى الطبال" />
        <meta name="author" content="Issa Omar Al-Tabbal" />
      </Helmet>
      <ScrollToTop />
    <>
      <Navbar />
      <Routes>
          <Route path="/" element={
            <>
            <Hero />
            <Containt />
            <Footer/>
            </>
          } />
          <Route path="/comingsoon" element={
            <>
            <NotFound />
            </>
          } />
      </Routes>
    </>
    </Router> 
  );
}

export default App;
